import { render } from "./AboutContent.vue?vue&type=template&id=3e9376ca&scoped=true"
import script from "./AboutContent.vue?vue&type=script&lang=js"
export * from "./AboutContent.vue?vue&type=script&lang=js"

import "./AboutContent.vue?vue&type=style&index=0&id=3e9376ca&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e9376ca"]])

export default __exports__